<script>
import MetabaseDashboard from "@components/metabase/MetabaseDashboard.vue";
export default {
  name: "home",
  components: {
    MetabaseDashboard
  }
}
</script>

<template>
  <vx-card title="Metabase">
    <metabase-dashboard
        :dashboard-id="56"
        params="theme=transparent&bordered=false&titled=false" />
  </vx-card>
</template>

<style scoped>

</style>